// Libraries
import {createGlobalStyle} from 'styled-components';

const PrintLetterStyle = createGlobalStyle`
  /* stylelint-disable unit-allowed-list */

  @media print {
    @page {
      size: letter;
      margin: 0.5in;
    }
  }
`;

export default PrintLetterStyle;
